import { format } from 'date-fns';
import { EChartsOption, ToolboxComponentOption } from 'echarts';
import { XAXisOption, YAXisOption } from 'echarts/types/dist/shared';
import { colors } from 'styles/colors';
import { capitalizeFirstLetter } from '~/helpers/capitalizeFirstLetter';
import { defaultDateFnsLocale } from '~/helpers/locale';

export const defaultChartOptions: Partial<EChartsOption> = {
  grid: {
    left: '10',
    right: '20',
    top: '40',
    bottom: '0%',
    containLabel: true,
  },
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'shadow',
    },
    backgroundColor: 'transparent',
    shadowBlur: 0,
    shadowOffsetX: 0,
    shadowOffsetY: 0,
    borderWidth: 0,
  },
};

export const defaultConfigsChart = {
  fontFamily: 'Inter',
  fontSize: '10px',
  fontWeight: 400 as NonNullable<ToolboxComponentOption['textStyle']>['fontWeight'],
  color: colors.text['sub-350'],
};

export const defaultYAxisConfig: YAXisOption = {
  type: 'value',
  splitNumber: 5,
  position: 'left',
  axisLabel: {
    ...defaultConfigsChart,
    align: 'right',
    fontSize: 9,
  },
  offset: 8,
  axisLine: { show: false },
  axisTick: {
    show: true,
    lineStyle: {
      color: defaultConfigsChart.color,
    },
  },
  splitLine: {
    show: true,
    lineStyle: {
      type: 'dashed',
    },
  },
};

export const defaultXAxisConfig : XAXisOption = {
  type: 'category',
  boundaryGap: false,
  splitLine: { show: false },
  axisLabel: {
    ...defaultConfigsChart,
    show: true,
    align: 'center',
    showMaxLabel: true,
    interval: 0,
    padding: [0, 0, 0, 0],
    fontSize: defaultConfigsChart.fontSize,
  },
  axisLine: { show: false },
  axisTick: {
    show: true,
    lineStyle: {
      color: defaultConfigsChart.color,
      width: 0.8,
    },
  },
  nameLocation: 'middle',
};

export const mediaQueryXAxis: NonNullable<EChartsOption['media']>[number] = {
  query: {
    maxWidth: 768,
  },
  option: {
    xAxis: {
      axisLabel: {
        fontSize: '8px',
      },
    },
  },
};

export const X_AXIS_DAYS = ['1', '5', '10', '15', '20', '25', '30'];

export function formatterXAxisLabel(value: string, type: 'month' | 'day', disabled?: boolean): string {
  const date = new Date(value);

  if (disabled) {
    return capitalizeFirstLetter(format(date, 'MMMM', { locale: defaultDateFnsLocale }));
  }

  if (type === 'month') {
    const monthLabel = capitalizeFirstLetter(format(date, 'MMM', { locale: defaultDateFnsLocale }));
    const yearLabel = format(date, 'yyyy', { locale: defaultDateFnsLocale });

    return `${monthLabel}\n\n${yearLabel}`;
  }

  const day = date.getDate().toString();

  return X_AXIS_DAYS.includes(day) ? day : '';
}
